import clown_skateboarding from 'url:../../assets/taco/Clown Skateboarding.png';
import clown_car from 'url:../../assets/taco/Clown in Car 4.png';
import circus_tent from 'url:../../assets/taco/Circus Tent 8.png';
import unicycle_dog_1 from 'url:../../assets/taco/Dog on Unicycle 1.png';
import unicycle_dog_2 from 'url:../../assets/taco/Dog on Unicycle 2.png';
import chili_pepper from 'url:../../assets/taco/Chili Pepper - Cowboy.png';
import logo from 'url:../../assets/taco/LOGO3.png';
import map_path from 'url:../../assets/taco/taco-map-path.png';
import { useNavigate } from 'react-router';
import { useContext } from 'react';
import TACOProvider from './TACOProvider';

export function TACOMAP() {
    const tacoProvider = useContext(TACOProvider.context);

    return <div className="v-box pos-rel" style={{
        width: 640,
        height: 880
    }}>
        <div className='pos-abs taco-box' style={{top:0, left:0, right:0, bottom: 0}}> </div>
        <MapImage src={map_path} x={12} y={5} w={70} />
        <MapBox x={60} y={0} w={40} h={10} text="Bongo's sauce recipe has changed 20 times over the franchise's history! Try our Pink Sauce for a flavor explosion!" />
        <MapBox x={-3} y={25} w={40} h={8} text="Bongo's favorite order is a Bongo Meal + toy with three ring onion hoops and a medium Sipper!" />
        <MapBox x={-3} y={38} w={40} h={8} text="UNFORTUNATELY, dogs can't eat onions. That's why he cries! Sorry, Bongo!" />
        <MapImage src={clown_car} x={6} y={0} w={30} class='flip-h' />
        <MapImage src={clown_skateboarding} x={70} y={20} w={30} />
        <MapImage src={unicycle_dog_1} x={27} y={64} w={12} class='flip-h' />
        <MapImage src={unicycle_dog_2} x={48} y={68} w={12} class='flip-h'/>
        <MapImage src={chili_pepper} x={42} y={34} w={8} />
        <MapImage src={circus_tent} x={60} y={80} w={40} onClick={() => { tacoProvider.enterShop(); }} />
        <MapImage src={logo} x={75} y={95} w={25} class='no-events' />
    </div>
}

function MapBox (
    props: {
        text: string,
        x: number,
        y: number,
        w: number,
        h: number,
        class?: string
    }
) {
    const className = props.class !== undefined ? props.class : '';

    return <div className={"pos-abs taco-map-box text-center v-box center-all " + className} style={{ 
        left: props.x + "%",
        top: props.y + "%",
        width: props.w + "%",
        height: props.h + "%"
    }}>
        { props.text }
    </div>
}

function MapImage (
    props: {
        src: string,
        x: number,
        y: number,
        w: number,
        onClick ?: () => void,
        class ?: string
    }
) {
    const onclick = props.onClick !== undefined ? props.onClick : () => {};
    const className = props.class !== undefined ? props.class : '';
    return <img src={props.src} onClick={onclick} className={"pos-abs " + className} style={{
        left: props.x + "%",
        top: props.y + "%",
        width: props.w + "%"
    }} />
}